import React  from 'react';
import BlogRequestBasicInfoComponent from './blog-request-basic-info.component';
import TabContainer from '../../../../../../common/components/tab/containers/tab.containers';

export const BlogRequestComponent = ({influencer,handleBlogPost,taskStatus, handleInnerFormChange, selectedBlog,back,handleFormSubmit}: any) => {
  const tabItems=[
    {
        id:1,
        title:'Blog Request Information',
        component:
        <BlogRequestBasicInfoComponent   handleInnerFormChange={handleInnerFormChange}
        taskStatus={taskStatus}
        handleFormSubmit={handleFormSubmit}
        back={back}
        selectedBlog={selectedBlog}
        handleBlogPost={handleBlogPost}
        influencer={influencer} />,
    isVisible:true,
    },
    
  ]
    
  return (
    <>
    
      <TabContainer tabItems={tabItems} />
    
      <div className='flex w-full justify-end items-end'>
        <button
              onClick={back}
              type='button'
              className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
             >
              Back
             </button>
             <button
            className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
              onClick={handleFormSubmit}
            
              type="submit"
          >
            Save
          </button>
        </div>
    </>
  )
}
export default BlogRequestComponent;
